/** Invalidation hints only. Viewers reload through the authorized API. */
export const eventChangeChannel = "mzn-event-changes";
export function notifyEventChange() {
  window.dispatchEvent(new Event(eventChangeChannel));
  try {
    const channel = new BroadcastChannel(eventChangeChannel);
    channel.postMessage("changed"); channel.close();
  } catch { /* Focus and periodic refresh also work without BroadcastChannel. */ }
}
